// Actions

const APPLICATION_LOADING = 'APPLICATION_LOADING';
const APPLICATION_LOADING_SUCCESS = 'APPLICATION_LOADING_SUCCESS';

// Actions creators

const loadApplication = () => (({
    type: APPLICATION_LOADING
}));

const loadApplicationSuccess = () => ({
    type: APPLICATION_LOADING_SUCCESS
});

export default {
    loadApplication,
    loadApplicationSuccess
};

const initialState = false;

// Reducers
export function applicationLoadingReducer(state = initialState, action) {
    switch (action.type) {
        case APPLICATION_LOADING:
            return true;
        case APPLICATION_LOADING_SUCCESS:
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/applicationLoading.js